enum LogoName {
  TommyHilfiger = 'TommyHilfiger',
  GuidoMaria = 'GuidoMaria',
  Lascana = 'Lascana',
  Hugo = 'Hugo',
  Netflix = 'Netflix',
}

export const filterLogoAssets: {[key in LogoName]: string} = {
  [LogoName.TommyHilfiger]: require('./x-tommy-hilfiger.svg'),
  [LogoName.GuidoMaria]: require('./x-kleiner-GMK.svg'),
  [LogoName.Lascana]: require('./x-lascana-logo-black.svg'),
  [LogoName.Hugo]: require('./x-hugo-logo.svg'),
  [LogoName.Netflix]: require('./x-netflix-logo.svg'),
};
